
import MobileDetect from 'mobile-detect';

let md = null;

if( typeof(window) != undefined ) {
    md = new MobileDetect(window.navigator.userAgent);
}

export const isTouchDevice = () => {
    if(md) {
        return md.mobile() != null;
    }
    return false;
}




// WEBPACK FOOTER //
// ./src/service/MobileService.js